export const SIN_BIDATA={
    SP03:true
}